// Define your Flags
export var FeatureFlagEnum;
(function (FeatureFlagEnum) {
    FeatureFlagEnum["RedirectSpanishWhenPendingAssessment"] = "RedirectSpanishWhenPendingAssessment";
})(FeatureFlagEnum || (FeatureFlagEnum = {}));
